"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "caldiero": {
    "a6e8147f": [{
      "hkey": "1132df88",
      "slug": "caldierino-rota",
      "name": "Caldierino-Rota",
      "primary": true,
      "skipSearch": false
    }],
    "caldierino": [{
      "hkey": "1132df88",
      "slug": "caldierino-rota",
      "name": "Caldierino-Rota",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "24eea552": [{
      "hkey": "201dd178",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "localita-stra": [{
      "hkey": "201dd178",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caldiero"
    }]
  }
};
exports["default"] = _default;